// react components
import React, {
    useState,
} from 'react'

// data
import {
    contentTypeModelTypeSite,
} from 'data'

// pages
import {
    ActionComponent825,
    TableColumn825,
} from 'pages'

// serializers
import {
    ContentTypeSettingsCustomTypes,
    ContentTypeSettingsTypes,
} from 'serializers/site'

// props
type TableRow825Props = {
    addProfileColumn?: boolean
    checkboxAddRemove?: any
    checkboxArray?: number[]
    checkboxShow?: boolean
    columns: string[]
    columnsCustom?: string[]
    componentActionSheet?: string
    contentType: contentTypeModelTypeSite
    contentTypeSettings: ContentTypeSettingsTypes
    contentTypeSettingsCustom: ContentTypeSettingsCustomTypes | undefined
    defaultFields: any
    inModal?: boolean
    modalKey: number
    object: any
    profileObject: any | undefined
    refreshData?: () => void
    setFilter?: (e: any, f?: any) => void
}

// main
export const TableRow825: React.FC<TableRow825Props> = React.memo(({
    addProfileColumn,
    columns,
    columnsCustom,
    componentActionSheet,
    contentType,
    contentTypeSettings,
    contentTypeSettingsCustom,
    defaultFields,
    inModal,
    modalKey,
    object,
    profileObject,
    refreshData,
    setFilter,
}) => {

    const [deleted, setDeleted] = useState(false)
    const [showActionPopover, setShowActionPopover] = useState(false)

    const newColumns = columnsCustom || columns || []

    return (
        <tr
            className='table-row'
            style={{
                display: deleted ? 'none' : undefined,
            }}
        >
            <td
                className='tr-action'
            >
                <div className='tr-action-div'>
                    {componentActionSheet && (
                        <ActionComponent825
                            contentType={contentType}
                            contentTypeSettings={contentTypeSettings}
                            defaultFields={defaultFields}
                            edit={false}
                            inModal={inModal}
                            modalKey={modalKey}
                            object={object}
                            refreshData={refreshData ? refreshData : () => undefined}
                            refreshList={refreshData}
                            setDeleted={setDeleted}
                            setShowActionPopover={setShowActionPopover}
                            showActionPopover={showActionPopover}
                        />
                    )}
                </div>
            </td>
            {newColumns.map(val => (
                <TableColumn825
                    key={val}
                    addProfileColumn={addProfileColumn}
                    contentType={contentType}
                    contentTypeSettings={contentTypeSettings}
                    contentTypeSettingsCustom={contentTypeSettingsCustom}
                    field={val}
                    modalKey={modalKey}
                    object={object}
                    profileObject={profileObject}
                    refreshData={refreshData ? refreshData : () => undefined}
                    setFilter={setFilter}
                />
            ))}
        </tr>
    )
})
